/**
 * @file Renders the Authenticator's confirm-sign-in step header.
 */
import { useAuthenticator } from "@aws-amplify/ui-react";

import FormHeader from "./FormHeader";

const LABEL_HEADING = "Sign In Confirmation";
const LABEL_DEFAULT_TEXT = "Enter the confirmation code to continue signing in.";
const LABEL_SMS_TEXT = "A confirmation code was sent to the mobile number linked to your account. Please enter the confirmation code below. It might take a few moments for the code to arrive.";
const LABEL_TOTP_TEXT = "Open your authenticator app and enter the confirmation code shown for your account.";

const SMS_CHALLENGE = "SMS_MFA";
const TOTP_CHALLENGE = "SOFTWARE_TOKEN_MFA";

/**
 * Renders the confirm-sign-in heading and the instructions that match the
 * user's current MFA challenge.
 */
const ConfirmSignInHeader = (): JSX.Element => {
  const { user } = useAuthenticator((context) => [ context.user ]);

  const challengeName = user?.challengeName;
  const isSmsChallenge = challengeName === SMS_CHALLENGE;
  const isTotpChallenge = challengeName === TOTP_CHALLENGE;

  let text = LABEL_DEFAULT_TEXT;

  if (isSmsChallenge) {
    text = LABEL_SMS_TEXT;
  }

  if (isTotpChallenge) {
    text = LABEL_TOTP_TEXT;
  }

  return (
    <FormHeader
      heading={LABEL_HEADING}
      text={text}
    />
  );
};

export default ConfirmSignInHeader;
